(function () {
    'use strict';

    /**
     * Topics section - owns its data and loading.
     * Used as an attribute on the server rendered <section> (Views/Events/_Topics.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "topicsSection"
     * and still sees the page "vm" (getStyle, showLoading).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionTopics', sectionTopics);

    function sectionTopics() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionTopicsCtrl,
            controllerAs: 'topicsSection'
        };
    }

    SectionTopicsCtrl.$inject = ['$element', 'ApiFactory', 'SectionRegistry'];

    function SectionTopicsCtrl($element, ApiFactory, SectionRegistry) {
        const vm = this;
        vm.items = [];

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * Load the topics of the event
         * @param {number} eventId
         * @param {number} lang
         * @returns {Promise<boolean>} true when data was received
         */
        function load(eventId, lang) {
            return ApiFactory.GetTopics(eventId, lang).then(function (response) {
                if (response.data == null)
                    return false;

                vm.items = response.data;
                return true;
            });
        }
    }
})();
